import { $myFetch } from "."
import { IBusinessUnitResult, ITranslations } from "../../models"
import { Roles, changeBu } from "../../utils"
import { responseType, transform } from "../../utils/http-res-handler"

export const $getRole = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(`role`, {
    headers: myHeaders,
  })
}

export const $getManagedSupplierList = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(`marketLeader`, {
    headers: myHeaders,
  })
}

export const $getBusinessUnit = (
  role: Roles,
  translations: ITranslations["toastrLabels"]
): Promise<IBusinessUnitResult> => {
  const myHeaders = new Headers()
  changeBu(null)
  return $myFetch(
    `businessUnit`,
    {
      headers: myHeaders,
    },
    [],
    role
  )
    .then((res) => transform(res, translations, responseType.json))
    .then((res) => res as IBusinessUnitResult)
    .then((res) => {
      changeBu(res)
      return res
    })
}
